export default [{
  "title": "РПЛ",
  "pathName": "rpl",
  "childRoutes": [{
    "title": "Таблица",
    "pathName": "rankings",
    "childRoutes": []
  },
  {
    "title": "Календарь",
    "pathName": "schedule",
    "childRoutes": []
  }]
}, {
  "title": "ЛЧ",
  "pathName": "cl",
  "childRoutes": [{
    "title": "Таблица",
    "pathName": "rankings",
    "childRoutes": []
  }, {
    "title": "База прогнозов",
    "pathName": "predictions",
    "childRoutes": []
  }]
}];


// WEBPACK FOOTER //
// ./src/config/routesInfo.ts